// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"16037f96","977":"62ba14fb"}[chunkId] + ".chunk.js";
};